/**
 * Utility to generate WhatsApp links based on device type.
 * Opens the app on mobile and WhatsApp Web on desktop.
 */

export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

/**
 * Generates a WhatsApp link.
 * @param phone The phone number (with or without + or other characters)
 * @param text Optional text message to pre-fill
 * @returns A URL string
 */
export const getWhatsAppLink = (phone: string, text?: string): string => {
  const digits = phone.replace(/\D/g, '');
  const encodedText = text ? encodeURIComponent(text) : '';

  const base = isMobileDevice() ? 'https://api.whatsapp.com/send' : 'https://web.whatsapp.com/send';

  let url = `${base}?phone=${digits}`;
  if (encodedText) {
    url += `&text=${encodedText}`;
  }

  return url;
};

/**
 * Standard text-only WhatsApp share link (without a specific phone number)
 * Useful for sharing content to any contact.
 */
export const getWhatsAppShareLink = (text: string): string => {
  const encodedText = encodeURIComponent(text);

  const base = isMobileDevice() ? 'https://api.whatsapp.com/send' : 'https://web.whatsapp.com/send';

  return `${base}?text=${encodedText}`;
};
